export enum RedemptionMethod {
  Annuities = 'Annuiteiten',
  Linear = 'Lineair',
  InterestOnly = 'Aflossingsvrij'
}
